/* document.addEventListener('DOMContentLoaded', function () {
    var checkbox = document.querySelector('.es_subscribe');
    var panel = document.querySelector('.es_secureSubscriptionPlan');
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0';
      }
    });
  }); */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-actions__add-to-cart-button').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      // Get quantity
     // var quantityInput = document.querySelector('.input.input--primary.product-quantity__input');
     // var quantity = quantityInput ? quantityInput.value : 1;

      // Get selected radio button value (if any)
      var selectedPlanInput = document.querySelector('.es_radio-image-group input[name="product_option"]:checked');
      var selling_plan = selectedPlanInput ? selectedPlanInput.value : null;

      // Get selected value from the dropdown
      var selectedMain = document.querySelector('.product-selectors select');
      var selectedOptionText = selectedMain.options[selectedMain.selectedIndex].text;

      // Set variant ID based on selected option text
      var selling_planMain;
      if (selectedOptionText === "Annual") {
        selling_planMain = 50520599888192;
      } else {
        selling_planMain = 50520599822656;
      }

      // Create cart items array
      var items = [
        {
          id: selling_planMain,
          quantity: 1,
        },
        {
          id: 50517595717952,
          quantity: 1,
          selling_plan: selling_plan,
        }
      ];

      // Send add-to-cart request
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (response.ok) {
          console.log('Items added to cart successfully.');
          window.location.href = '/checkout';  // Uncomment to redirect
        } else {
          return response.json().then(err => {
            console.error('Error:', err);
          });
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const radioButtons = document.querySelectorAll('.es_radio-image-group input[name="product_option"]');
  radioButtons.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.checked) {
        const selectedValue = this.value;
        const selector = document.querySelector('.product-selectors select');
        if (!selector) return;
        if (selectedValue === "693069152576") {
          selector.value = "Monthly";
        } else {
          selector.value = "Annual";
        }
        // Optional: Manually trigger a change event if needed
        const changeEvent = new Event('change', { bubbles: true });
        selector.dispatchEvent(changeEvent);
      }
    });
  });
});





